import { lazy } from 'react';

const Pivot = lazy(() => import('../../../modules/reporting/pivot/').then((module) => ({ default: module.Global })));

export default {
  path: 'pivot',
  element: <Pivot />,
};
